import sdk from '@psp-aggregator/sdk';

export const useProviderOptions = (enabled = true) =>
  sdk.queries.useGetProviderOptions({ enabled });
